import { render, staticRenderFns } from "./Oportunidades.vue?vue&type=template&id=307b6592&scoped=true&"
import script from "./Oportunidades.vue?vue&type=script&lang=js&"
export * from "./Oportunidades.vue?vue&type=script&lang=js&"
import style0 from "./Oportunidades.vue?vue&type=style&index=0&id=307b6592&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307b6592",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
